import axios from "axios";
import React, { useContext, useEffect, useMemo, useState } from "react";
import Product from "../Product/Product";
import Loading from "../Loading/Loading";
import BaseURL from "../Utilities/BaseUrl";
import {cartContext}from'../Contexts/CartContext';
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
export default function Products() {
 let {setcheck}= useContext(cartContext);
 
  const [products, setproducts] = useState([]);
  async function getProducts() {
    let { data } = await axios.get(
      `${BaseURL}products`);

    setproducts(data.data);
    setcheck(true)
  }
  
 
  useEffect(() => {
    setcheck(false)
    getProducts();
  }, []);


  return (
    <><Helmet>
    <title>products</title>
    
</Helmet>
      {products.length > 0 ? (
        <div className="container pt-5 mt-5">
          <div className="row gy-4">
            <Product products={products} />
          </div>
        </div>
      ) : (
        <Loading />
      )}
    </>
  );
}
